import React, { memo, PropsWithChildren } from 'react';
import styled from 'styled-components';
import { BaseDiv } from '../../../common/BaseElements';
import { IResponsiveGutterProps, useResponsiveGutterCss, useResponsiveGapCss, IResponsiveGapProps } from './spaceResponsive';

export interface IResponsiveSpaceContainerProps extends PropsWithChildren, IResponsiveGutterProps {}

const ResponsiveGutterContainer = styled(BaseDiv)<IResponsiveGutterProps>`
  ${useResponsiveGutterCss()}
`;

const ResponsiveSpaceContainerInternal = React.forwardRef<HTMLDivElement, IResponsiveSpaceContainerProps>(({ children, ...rest }, ref) => (
  <ResponsiveGutterContainer ref={ref} {...rest}>
    {children}
  </ResponsiveGutterContainer>
));

export const ResponsiveSpaceContainer = memo(ResponsiveSpaceContainerInternal);

const CommonResponsiveGapContainer = styled(BaseDiv)<IResponsiveGapProps & IResponsiveGutterProps>`
  ${useResponsiveGapCss()}
  ${useResponsiveGutterCss()}
`;

const ResponsiveGapContainerInternal = styled(
  React.forwardRef<HTMLDivElement, React.PropsWithChildren<IResponsiveGapProps & IResponsiveGutterProps>>(({ children, ...rest }, ref) => (
    <CommonResponsiveGapContainer ref={ref} {...rest}>
      {children}
    </CommonResponsiveGapContainer>
  ))
)``;

export const ResponsiveGapContainer = memo(ResponsiveGapContainerInternal);
